import { useTranslation } from "react-i18next";
import Seo from "@/components/Seo";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

export default function Privacy() {
  const { t } = useTranslation();
  const sections = t("privacy.sections", { returnObjects: true }) as {
    h: string;
    p: string;
  }[];

  return (
    <div className="min-h-screen flex flex-col bg-background text-foreground">
      <Seo title={t("privacy.metaTitle")} description={t("privacy.metaDesc")} path="/privacy" />
      <Header />
      <main id="main" tabIndex={-1} className="flex-1 outline-none">
        <section className="w-full px-6 pt-16 pb-12 md:pt-24 md:pb-16">
          <div className="max-w-[1400px] mx-auto">
            <div className="flex flex-col gap-3 ed-eyebrow text-muted-foreground sm:flex-row sm:items-center sm:justify-between animate-fade-in">
              <span className="inline-flex items-center gap-2">
                <span className="inline-block w-1.5 h-1.5 rounded-full bg-brand ed-blink" />
                {t("privacy.eyebrow")}
              </span>
              <span>{t("privacy.updated")}</span>
            </div>

            <h1 className="ed-display mt-8 max-w-[14ch] animate-fade-in">
              {t("privacy.title")}<span className="text-brand">.</span>
            </h1>

            <p className="ed-serif mt-8 text-2xl md:text-3xl max-w-3xl text-foreground/85 animate-fade-in-delay-1">
              {t("privacy.intro")}
            </p>
          </div>
        </section>

        <div className="ed-rule max-w-[1400px] mx-auto" />

        <section className="w-full px-6 py-12 md:py-20">
          <ol className="max-w-[1100px] mx-auto">
            {sections.map((s, i) => (
              <li
                key={s.h}
                className="grid gap-4 md:grid-cols-[auto_1fr] md:gap-12 py-10 border-b border-border"
              >
                <span className="ed-serif text-3xl md:text-4xl text-muted-foreground">
                  0{i + 1}
                </span>
                <div>
                  <h2 className="ed-headline">{s.h}</h2>
                  <p className="mt-4 text-lg text-muted-foreground leading-relaxed max-w-2xl">
                    {s.p}
                  </p>
                </div>
              </li>
            ))}
          </ol>
        </section>
      </main>
      <Footer />
    </div>
  );
}
